import { ChangeDetectionStrategy, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { IntlService } from '@sinequa/core/intl';
import { TreeAggregationNode, Results, AggregationItem } from '@sinequa/core/web-services';
import { SearchService } from '@sinequa/components/search';
import { FacetService } from '@sinequa/components/facet';
import { DropdownValues } from '../constant';

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FiltersComponent implements OnInit {

  constructor(private intlService: IntlService, public searchService: SearchService, private facetService: FacetService) { }

  @Input() modal: boolean;

  @Input() aggregations: TreeAggregationNode[] | AggregationItem;

  @Input() results: Results;

  checkedList: any = [];

  public dropdownsList: any =
    // value is the aggregationMap name property
    [{ 'name': this.intlService.formatMessage("msg#label.projectType"), 'value': DropdownValues.projectType, 'checkedList': [], 'display': '' },
    { 'name': this.intlService.formatMessage("msg#label.therapyArea"), 'value': DropdownValues.disease, 'checkedList': [], 'display': '' },
    // { 'name': this.intlService.formatMessage("msg#label.category"), 'value': 'category', 'checkedList': [] },
    { 'name': this.intlService.formatMessage("msg#label.brand"), 'value': DropdownValues.brands, 'checkedList': [], 'display': '' },
    { 'name': this.intlService.formatMessage("msg#label.targetGroup"), 'value': DropdownValues.targetGroup, 'checkedList': [], 'display': '' },
    { 'name': this.intlService.formatMessage("msg#label.region/country"), 'value': DropdownValues.regions, 'checkedList': [], 'display': '' },
    { 'name': this.intlService.formatMessage("msg#label.researchMethod"), 'value': DropdownValues.researchMethod, 'checkedList': [], 'display': '' },
    { 'name': this.intlService.formatMessage("msg#label.supplier"), 'value': DropdownValues.supplier, 'checkedList': [], 'display': '' },
    { 'name': this.intlService.formatMessage("msg#label.publicationDate"), 'value': DropdownValues.publisedYear, 'checkedList': [], 'display': '' }]

  ngOnInit(): void {
    this.createDropdownList();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.aggregations) {
      this.aggregations = changes.aggregations.currentValue;
      this.createDropdownList();
    }
  }

  createDropdownList() {
    this.dropdownsList.forEach(dropdown => {
      if (this.aggregations[dropdown.value] && this.aggregations[dropdown.value].items && this.aggregations[dropdown.value].items.length > 0) {
        dropdown.display = this.aggregations[dropdown.value]?.name;
        if (dropdown.display === 'AZ_IV_PublishedYear') {
          this.aggregations[dropdown.value].items = this.aggregations[dropdown.value].items.filter(i => i.value);
        }
        dropdown.hide = false;
      } else {
        dropdown.hide = true;
      }
    })
  }

  clickOutside(dropdown: any) {
    if (dropdown.showOption) {
      dropdown.showOption = !dropdown.showOption;
    }
  }

  showOptions(dropdown: any) {
    this.dropdownsList.forEach(list => {
      list.showOption = !list.showOption;
      list['items'] = this.aggregations[dropdown.value].items;
      switch (dropdown.value) {
        // the aggreation array has object publishedyear mapped to publication Date
        case 'az_iv_publishedyear':
          let _tempList = this.aggregations[dropdown.value].items;
          list['items'] = _tempList.filter(i => i.value);
          break;
        default:
          list['items'] = this.aggregations[dropdown.value].items;
          break;
      }
    })
  }

  getSelectedValue(event: any) {
    this.dropdownsList.forEach(list => {
      if (list.display.includes(event.name)) {
        if (event.item.checked) {
          list.checkedList.push(event.item.value);
        } else {
          var index = list.checkedList.indexOf(event.item.value);
          list.checkedList.splice(index, 1);
        }
      }
    })
  }

  clearOptions(checkedList) {
    let unique = checkedList.filter(function (elem, index, self) {
      return index === self.indexOf(elem);
    })
    return unique;
  }

  clearFilter(name: string) {
    this.dropdownsList.forEach(list => {
      if (list.display.toLowerCase().includes(name.toLowerCase())) {
        list.checkedList = [];
      }
    })
  }

  clearAll() {
    this.dropdownsList.forEach(dropdown => {
      dropdown.showOption = false;
      if (dropdown.checkedList && dropdown.checkedList.length > 0) {
        dropdown.checkedList = [];
        dropdown.items.forEach(item => {
          item.checked = false;
        })
      }
      this.facetService.clearFiltersSearch(dropdown.display, true);
    });
  }
}
